import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import type {
  StaffList,
  StaffListDataUpdate,
  StaffListStatus,
} from "@/builders/types/staff-list";

import { activate_deactivate } from "./activate-or-deactivate";
import { id } from "./id";
import { trigger } from "./trigger";
import { type } from "./type";

const get = function (params?: FilterParams<{ status?: StaffListStatus }>) {
  return api.get<StaffList>("staffs", { params }).then(({ data }) => data);
};

const update = function (data: StaffListDataUpdate) {
  return api.put("staffs/update", data).then(({ data }) => data);
};

const post = function (data: {
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  staff_id: number | string;
  rank_id: number;
  location: string;
}) {
  return api.post("staffs", data).then(({ data }) => data);
};

export const staffs = {
  get,
  post,
  id,
  update,
  trigger,
  type,
  activate_deactivate,
};
